import { render, staticRenderFns } from "./codeDialog.vue?vue&type=template&id=60cf75f4&scoped=true&"
import script from "./codeDialog.vue?vue&type=script&lang=js&"
export * from "./codeDialog.vue?vue&type=script&lang=js&"
import style0 from "./codeDialog.vue?vue&type=style&index=0&id=60cf75f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf75f4",
  null
  
)

export default component.exports